import * as d3 from "d3";
import ImgLogo from "../../../assets/images/metodology-radar-logo.svg";
import ImgLogoMock from "../../../assets/images/radar-logo-mock.svg";
import ImgLogoMolecule from "../../../assets/images/logotype-molecule.svg";
import ImgLogoMoleculeTwo from "../../../assets/images/moleculeTwo/logotype.svg";
import {ITypeRadar} from "../../../types";

const logoMap: Partial<Record<ITypeRadar, string>> = {
  molecula: ImgLogoMolecule,
  moleculeTwo: ImgLogoMoleculeTwo,
  map: ImgLogo,
};

const renderLogoImage = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  isShowLogotypeGpb: boolean,
  logoRadius: number,
  typeRadar: ITypeRadar
) => {
  let logoImg;
  if (typeRadar !== "molecula" && typeRadar !== "moleculeTwo") {
    logoImg = isShowLogotypeGpb ? ImgLogo : ImgLogoMock;
  } else {
    logoImg = logoMap[typeRadar];
  }

  mainGroup
    .append("image")
    .attr("xlink:href", logoImg || ImgLogo)
    .attr("x", -logoRadius)
    .attr("y", -logoRadius)
    .attr("width", logoRadius * 2)
    .attr("height", logoRadius * 2);
};

export default renderLogoImage;
